import { raw, custom } from 'serializr';
import { createModelSchema } from '@services/EntityCache';
import type { IMoney } from '@type/IMoney';

export class Money implements IMoney {
  value!: number;

  currency!: { code: string };
}

export const moneySchema = createModelSchema(Money, {
  value: custom(String, Number),
  currency: raw()
});
